import { Skeleton } from "@mui/material";
import { useAvailabilityProfileData } from "@/lib/profile/availabilityProfileData";

export default function AvailabilityProfileSkeleton() {
    const {
        isDarkMode,
    } = useAvailabilityProfileData();

    const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 50 };

    return (
        <div className="space-y-6">
            <div>
                <Skeleton
                    animation="wave"
                    variant="text"
                    width={200}
                    height={32}
                    sx={skeletonSx}
                />
                <Skeleton
                    animation="wave"
                    variant="text"
                    width={180}
                    height={24}
                    className="mb-4"
                    sx={skeletonSx}
                />
                <div className="space-y-4">
                    {[...Array(7)].map((_, index) => (
                        <div
                            className={`border rounded-lg p-4 transition-colors duration-300 ${isDarkMode ? "border-gray-700" : "border-gray-200"
                                }`}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width={180}
                                        height={24}
                                        sx={skeletonSx}
                                    />
                                </div>
                                <Skeleton
                                    animation="wave"
                                    variant="text"
                                    width={110}
                                    height={50}
                                    sx={skeletonSx}
                                />
                            </div>

                            <div className="space-y-2">
                                    <div className="flex items-center gap-2">
                                        <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width={130}
                                            height={50}
                                            sx={skeletonSx}
                                        />
                                        <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width={130}
                                            height={50}
                                            sx={skeletonSx}
                                        />
                                    </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* Save Button */}
            <div className="flex justify-end pt-4 border-t border-gray-200">
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={140}
                    height={40}
                    className="rounded"
                    sx={skeletonSx}
                />
            </div>
        </div>
    );
}
